export default __webpack_public_path__ + "static/media/1957.c1659f0e.png";